import Dexie, { PromiseExtended, Table, Transaction } from 'dexie';
import { db } from './db';

// https://stackoverflow.com/questions/64114482/aborting-dexie-js-query

export function cancellableDexieQuery(
  includedTables: (string | Table)[],
  querierFunction: () =>
    | Promise<any>
    | PromiseExtended<any>
    | (Promise<any> | PromiseExtended<any> | (() => void))[]
): [Promise<any>, () => void] {
  var tx: Transaction | null = null;
  var cancelled = false;
  const promise = db.transaction('r', includedTables, () => {
    if (cancelled) throw new Dexie.AbortError('Query was cancelled');
    tx = Dexie.currentTransaction;
    return querierFunction();
  });
  // Clear tx when the transaction settles so cancel() doesn't try to abort an already-finished tx.
  promise.then(() => { tx = null; }, () => { tx = null; });
  return [
    promise,
    () => {
      cancelled = true; // In case transaction hasn't been started yet.
      if (tx) {
        try {
          tx.abort(); // If started, abort it.
        } catch (_) {
          // Transaction may have already finished; ignore the InvalidStateError.
        }
        tx = null; // Avoid calling abort twice.
      }
    },
  ];
}
